import LowerBannerPanel from "../../panels/lowerBannerPanel/lowerBannerPanel"

function ArticleBannerPanel(story) {
  return (
    <LowerBannerPanel blok={story.blok} lower_banner_panel={story.article_banner_panel} />
  )
}

export default ArticleBannerPanel
